<template>
    <div class="top_con">
        <el-button type="primary" @click="back" style="margin-bottom:20px;">返回上一页</el-button>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="设备编号">
                    <el-input v-model="formInline.equipmentnum" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="设备归属人">
                    <el-input type="" v-model="formInline.belonger" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="设备产权编号">
                    <el-input type="" v-model="formInline.propertynum" placeholder="请输入"></el-input>
                </el-form-item>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" max-height="580px">
            <el-table-column  prop="newId"  label="ID"></el-table-column>
            <el-table-column prop="equipmentnum"  label="设备编号"></el-table-column>
            <el-table-column prop="propertynum"  label="产权编号" ></el-table-column>
            <el-table-column prop="belonger"  label="设备归属人" ></el-table-column>
            <el-table-column prop="rysy"  label="人员收益" ></el-table-column>
            <el-table-column prop="jccfee"  label="进出场费用" ></el-table-column>
            <el-table-column prop="sbsy"  label="设备收益" ></el-table-column>
            <!-- <el-table-column prop="zongji"  label="总计" ></el-table-column> -->
        </el-table>
        <!-- <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination> -->
    </div>
</template>
<script>
import {CashFlow} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            syid:'',
            formInline: {
                equipmentnum:'',
                belonger: '',
                propertynum: '',
                typec:''
            },
            dialogFormVisible:false,
            chuKu:false,
            zp_tit:"新增",
            tit_type:0,
            form:{
                typec:'',
                project: '',
                jine: '',
                beizhu:''
            },
            formLabelWidth: '120px',
            value:10,
            total:10,
            multipleSelection:[],
            tableData: [],
        }
    },
    methods:{
        clearS(){
            this.formInline={}
            CashFlow().then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        onSubmit(){
            let param ={
                formInline:this.formInline,
                id:this.syid
            }
            CashFlow(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        back(){
            this.$router.push({
                path:'/QueryPricing'
            })
        },
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        this.syid=this.$route.query.id
        this.info=this.$route.query.info
        this.formInline.typec=this.info.typec
        CashFlow({id:this.syid,formInline:this.info}).then(res=>{
            this.total=res.total;
            this.tableData=res.list;
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CashFlows.vue